/**
 * The front-face controls — everything that must stay one click away on the
 * chrome itself rather than behind the sidebar or the capability map.
 *
 * Exactly three things live here, and the list is deliberately short:
 *
 *  1. VoicePanel, WHOLE (speaker toggle + picker + stop). `onStopSpeaking` has
 *     exactly one call site in the frontend — VoicePanel's stop button — and
 *     TTS auto-plays on every assistant message. Behind a menu it would be
 *     unreachable at the only moment it matters.
 *  2. New chat.
 *  3. Sign out.
 *
 * Everything else the deleted header icon row carried (Learn, Memory, Signals,
 * the visual-tools dropdown, Settings, theme) now lives in the sidebar or the
 * Capabilities map. Adding a button back here needs the same test the three
 * above pass: it is needed WHILE something else is happening.
 */

import VoicePanel from './VoicePanel';

export default function FrontFaceControls({
  voiceEnabled,
  selectedVoiceId,
  isSpeaking,
  fetchVoices,
  onToggleVoice,
  onSelectVoice,
  onStopSpeaking,
  onNewChat,
  onLogout,
}) {
  return (
    <>
      <VoicePanel
        voiceEnabled={voiceEnabled}
        selectedVoiceId={selectedVoiceId}
        isSpeaking={isSpeaking}
        fetchVoices={fetchVoices}
        onToggleVoice={onToggleVoice}
        onSelectVoice={onSelectVoice}
        onStopSpeaking={onStopSpeaking}
      />
      <button
        className="front-face-btn"
        onClick={onNewChat}
        title="New conversation"
        aria-label="Start new conversation"
      >
        <NewChatIcon />
      </button>
      {onLogout && (
        <button
          className="front-face-btn front-face-btn--quiet"
          onClick={onLogout}
          title="Sign out"
          aria-label="Sign out"
        >
          <LogoutIcon />
        </button>
      )}
    </>
  );
}

// ============================================================
// ICONS
// ============================================================

function NewChatIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}
